var moduleMap = {
	"Applications": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(365)]).then(() => (() => ((__webpack_require__(9365)))));
	},
	"ApplyNow": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(160), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(338)]).then(() => (() => ((__webpack_require__(9338)))));
	},
	"ApplyViaTLPreapprovalModalButton": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(160), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(996)]).then(() => (() => ((__webpack_require__(5996)))));
	},
	"useApplyNowData": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(942), __webpack_require__.e(390)]).then(() => (() => ((__webpack_require__(4390)))));
	},
	"Apply": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(834)]).then(() => (() => ((__webpack_require__(1834)))));
	},
	"ContinueApplication": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(899)]).then(() => (() => ((__webpack_require__(1899)))));
	},
	"TopUpNotice": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(160), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(869), __webpack_require__.e(545)]).then(() => (() => ((__webpack_require__(1872)))));
	},
	"TopUpPopUp": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(160), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(869), __webpack_require__.e(475)]).then(() => (() => ((__webpack_require__(1458)))));
	},
	"TopUpModal": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(160), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(942), __webpack_require__.e(869), __webpack_require__.e(98)]).then(() => (() => ((__webpack_require__(869)))));
	},
	"NonLimDecommissionNotice": () => {
		return Promise.all([__webpack_require__.e(447), __webpack_require__.e(914), __webpack_require__.e(136), __webpack_require__.e(335)]).then(() => (() => ((__webpack_require__(3335)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});